import React from "react";
import { CV } from "../components/cv";
import JoenImg from "@/assets/images/joen.png";

export default function CVJoenMauritzon() {
  React.useEffect(() => {
    document.title = "BoldBrave CV - Joen Mauritzon";
  }, []);

  return (
    <CV
      name="Joen Mauritzon"
      photo={JoenImg}
      title="iOS Developer"
      subtitle="iOS developer with a broad systems background and a user-centred mindset — from idea and design to shipped feature."
      summary="Developer passionate about building smart, user-friendly solutions, above all within iOS. Thrives when producing technical solutions that actually get used, being involved the whole way from idea to finished product. With a background in systems development the experience is broad, but mobile development has been the focus in recent years. Works closely with other developers, designers and product teams to find the small details that make a big difference for the user, and consistently pushes stability, performance and user experience. Naturally curious about new frameworks, development methods and ways of using AI in everyday work."
      skills={{
        Mobile: ["Swift", "SwiftUI", "Objective-C", "Android SDK"],
        Backend: ["Java", "Spring", "gRPC", "GraphQL"],
        Web: ["React", "JavaScript"],
        "Delivery & Tooling": [
          "Feature flags",
          "A/B testing",
          "Remote configuration",
          "Bitrise",
          "Fastlane",
          "CI/CD",
          "Git",
          "AWS",
          "Scrum",
          "Claude Code",
        ],
        Languages: ["Swedish (native)", "English (fluent)"],
      }}
      experience={[
        {
          role: "iOS Developer (consultant at Volvo Cars)",
          company: "Consid, Lund",
          period: "2022 – 2026",
          description:
            "Part of the team behind the Volvo Cars App for iPhone, covering the full development chain from idea and design to finished feature.",
          highlights: [
            "Worked closely with designers, backend developers and testers to build new features and improve the user experience.",
            "Rolled out features safely using feature flags and A/B tests to measure that what was built worked as intended.",
            "Active in the internal iOS community at Volvo, sharing knowledge and experience across teams.",
          ],
        },
        {
          role: "iOS Developer",
          company: "Prisjakt, Ängelholm",
          period: "2018 – 2022",
          description:
            "Worked in a small, tight-knit team responsible for the entire iOS app — building new features and improving older parts, from Prisjakt Experts views to the search interface.",
          highlights: [
            "Drove a technical modernisation from Objective-C to Swift and moved the build environment from Jenkins to Bitrise.",
            "Introduced feature flags and remote configuration for safer, more controlled releases.",
            "Created a more stable and efficient development process with direct impact on app quality.",
          ],
        },
        {
          role: "Systems Developer",
          company: "Prisjakt, Ängelholm",
          period: "2015 – 2018",
          description:
            "Full-stack work on data collection, backend performance and internal tools — from database to frontend.",
          highlights: [
            "Built scrapers collecting price information from a range of retailers.",
            "Developed internal admin tools used daily by several departments.",
          ],
        },
        {
          role: "Systems Developer",
          company: "mBlox, Lund",
          period: "2011 – 2015",
          description:
            "Backend and customer-facing development in a company where robust systems and long-term code quality mattered.",
          highlights: [
            "Built demo apps for the sales team, tailored to different customer needs, and worked on the company's Android SDK.",
            "Java and Spring backend work, gradually modernising legacy systems for better testability and stability.",
            "Developed new services, including a fast number lookup service that improved internal systems.",
          ],
        },
      ]}
      education={[
        {
          degree: "AWS Certified Cloud Practitioner",
          institution: "Amazon Web Services",
          year: "2025",
        },
        {
          degree: "B.Sc. Computer Engineering (Högskoleingenjör Datateknik)",
          institution: "LTH Campus Helsingborg",
          year: "2008 – 2011",
        },
      ]}
    />
  );
}
